import { useSelector } from 'react-redux';
import { Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import { theme } from 'theme';
import MemberCodeIcon from 'assets/icons/Membercode.svg?react';
import { selectMemberCode, selectMemberCodeStatus } from 'selectors/memberCodeSelector';
import { MemberCodeOutputStatusEnum } from 'pco-product-service-internal-consumer';

const styles = (codeInValid: boolean) => {
  return {
    lineThrough: {
      fontSize: '16px',
      marginTop: theme.spacing(0.5),
      textDecoration: codeInValid ? 'line-through' : 'inherit',
    },
  };
};

export const MemberCode = () => {
  const memberCode: string = useSelector(selectMemberCode);
  const memberCodeStatus = useSelector(selectMemberCodeStatus);
  const isCodeInvalid =
    memberCodeStatus === MemberCodeOutputStatusEnum.Revoked || memberCodeStatus === MemberCodeOutputStatusEnum.Expired;

  return (
    <Card style={{ maxWidth: '90%', marginTop: theme.spacing(2) }} square>
      <Grid container style={{ paddingLeft: theme.spacing(2) }}>
        <MemberCodeIcon style={{ marginTop: theme.spacing(2) }} />
        <CardHeader
          title={'ACTIVATION CODE'}
          titleTypographyProps={{ variant: 'subtitle1' }}
          style={{
            paddingBottom: theme.spacing(1),
            paddingLeft: theme.spacing(1),
          }}
        />
      </Grid>
      <CardContent style={{ paddingTop: theme.spacing(0) }}>
        <Typography variant={'caption'}>Code</Typography>
        <Typography sx={styles(isCodeInvalid).lineThrough} variant={'body2'}>
          {memberCode}
        </Typography>
      </CardContent>
    </Card>
  );
};
